import React, { ReactElement } from "react";
import AttributeEditor from "@amzn/awsui-components-react-v3/polaris/attribute-editor";
import { ArrayFieldTemplateProps } from "@rjsf/utils";
import { itemLabel } from "../utils";

type Item = ArrayFieldTemplateProps["items"][0];

const noLabel = "\u00a0"; // Blank label (non-breaking space)

/** [Custom ArrayFieldTemplate](https://react-jsonschema-form.readthedocs.io/en/latest/advanced-customization/custom-templates/#arrayfieldtemplate). */
export default function ArrayFieldTemplate(
  props: ArrayFieldTemplateProps
): ReactElement {
  return (
    <AttributeEditor<Item>
      onAddButtonClick={props.onAddClick}
      onRemoveButtonClick={e =>
        props.items[e.detail.itemIndex].onDropIndexClick(e.detail.itemIndex)(e)
      }
      items={props.items}
      definition={[
        { label: itemLabel(props) ?? noLabel, control: item => item.children }
      ]}
      addButtonText={"Add item"}
      removeButtonText={"Remove"}
      isItemRemovable={item => item.hasRemove}
      disableAddButton={!props.canAdd}
    />
  );
}
